<template>
  <div>
    <div class="nav">
      <div class="inner">
      <img src="@/assets/images/logo.png" class="logo" />
        <div class="nav-bar">
          <div class="nav-top">
            <div class="nav-content">
              <ul class="nav-content-box">
                <li class="index on">
                  <i class="bottom-line"></i>
                  <span><span @click="go('/')">首页</span></span>
                </li>
                <li class="pro">
                  <i class="bottom-line"></i>
                  <span>
                    <span>产品中心</span>
                  </span>
                  <ul class="pro-item" style="padding: 0 23px">
                    <li><span @click="go('/crm')">CRM&SCRM</span></li>
                    <li><span @click="go('/marketingPlatform')">智能营销平台</span></li>
                    <li><span @click="go('/weChat')">企业微信应用</span></li>
                    <li><span @click="go('/datePlatform')">客户数据平台</span></li>
                  </ul>
                </li>
                <li class="programme">
                  <i class="bottom-line"></i>
                  <span><span >解决方案</span></span>
                  <ul class="programme-item" style="padding: 0 22px">
                    <li><span @click="go('/solution-market')">零售行业解决方案</span></li>
                    <li>
                      <span @click="go('/solution-conversion')">销售线索解决方案</span>
                    </li>
                  </ul>
                </li>
                <li class="case">
                  <i class="bottom-line"></i>
                  <span><span>合作案例</span></span>
                  <ul class="case-item" style="padding: 0 41px">
                    <li><span @click="go(`/caseCar?type=0&time=${new Date().getTime()}`)">服装</span></li>
                    <li><span @click="go(`/caseCar?type=1&time=${new Date().getTime()}`)">化妆品</span></li>
                    <li><span @click="go(`/caseCar?type=2&time=${new Date().getTime()}`)">消费品</span></li>
                    <li><span @click="go(`/caseCar?type=3&time=${new Date().getTime()}`)">汽车</span></li>
                  </ul>
                </li>
                <li class="about">
                  <i class="bottom-line"></i>
                  <span><span>关于我们</span></span>
                  <ul class="about-item" style="padding: 0 33px">
                    <li><span @click="go('/about')">关于我们</span></li>
                    <li><span @click="go('/recruit')">英檬招聘</span></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="btn">
          <el-button
            style="box-shadow: 5px 10px 10px rgba(0,0,0,.1)"
            type="primary"
            size="medium"
            @click="dialogFormVisible = true"
          >
            申请Demo体验
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="业务咨询与市场合作"
      :close-on-click-modal = "false"
      :close-on-press-escape = "false"
      :visible.sync="dialogFormVisible"
      width="550px" 
      @close="close"
    >
      <el-form :model="form" :rules="rules" ref="form" > 
        <el-form-item  prop="name">
          <span>*</span>
          <el-input v-model="form.name" autocomplete="off" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item   prop="company">
          <span>*</span>
          <el-input v-model="form.company" autocomplete="off" placeholder="公司"></el-input>
        </el-form-item>
        <el-form-item  prop="mobile">
          <span>*</span>
          <el-input v-model.number="form.mobile" autocomplete="off"  placeholder="联系电话"  maxlength="11"></el-input>
        </el-form-item>
        <el-form-item  prop="mail">
          <span>*</span>
          <el-input v-model="form.mail" autocomplete="off" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item  prop="content">
          <span>*</span>
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5}"
            placeholder="请输入内容"
            v-model="form.content"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="disabled" type="primary" @click="sure('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import config from "@/assets/config.json";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    }
    return {
      dialogFormVisible: false,
      disabled: false,
      form: {
          company: "",
          content: "",
          mail: "",
          mobile: "",
          name: ""
      },
      rules: {
        company: [
          { required: true, message: '请填写公司', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请填写内容', trigger: 'blur' }
        ],
        mail: [
          { required: true, message: '请填写邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        mobile: [
          { validator:checkPhone,trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ]
      }
    }
  },
  name: "nav-bar",
  mounted() {
    window.addEventListener("scroll",this.showbtn,true);
    this.$nextTick(() => {
      for(let i = 0; i <= 4; i++) {
        $(".bottom-line").eq(i).css("display", "none");
        $(".bottom-line").eq(i).siblings("span").children().css("color", "#004999")
      }
      if(this.$route.path === "/") {
        $(".bottom-line").eq(0).css("display", "block");
        $(".bottom-line").eq(0).siblings("span").children().css("color", "#64AC3A")
      } else if(
        this.$route.path === "/crm" ||
        this.$route.path === "/marketingPlatform" ||
        this.$route.path === "/weChat" ||
        this.$route.path === "/datePlatform"
      ) {
        $(".bottom-line").eq(1).css("display", "block");
        $(".bottom-line").eq(1).siblings("span").children().css("color", "#64AC3A")
      } else if (this.$route.path === "/solution-conversion" || this.$route.path === "/solution-market") {
        $(".bottom-line").eq(2).css("display", "block");
        $(".bottom-line").eq(2).siblings("span").children().css("color", "#64AC3A")
      }else if (this.$route.path === "/caseCar") {
        $(".bottom-line").eq(3).css("display", "block");
        $(".bottom-line").eq(3).siblings("span").children().css("color", "#64AC3A")
      }else if (this.$route.path === "/about" || this.$route.path === "/recruit") {
        $(".bottom-line").eq(4).css("display", "block");
        $(".bottom-line").eq(4).siblings("span").children().css("color", "#64AC3A")
      }
    })
  },
  destroyed() {
    window.removeEventListener("scroll",this.showbtn,true);
  },
  methods: {
    sure(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.disabled = true;
            this.$axios({
              method:'post',
              // url:'https://tst-phd.remycn.com/octomore-sms/octomore/mail',
              url: `${config.api.api}/indation/common/mail`,
              data: this.form
            }).then((response) =>{  
              if(response.data.code === 200){
                this.dialogFormVisible = false;
                this.$message.success('提交成功');
                this.disabled = false;
              } else {
                this.$message.error('提交失败');
                this.disabled = false;
                return false;
              }
            }).catch((error) => {
              this.$message.error(error); //请求失败返回的数据
              this.disabled = false;
            })
          } else {
            this.$message.warning('请将内容填写完整') //请求失败返回的数据
            this.disabled = false;
            return false;
          }
        });
    },
    close(){
        this.$refs.form.clearValidate()
        this.form.company = ""
        this.form.content = ""
        this.form.mail = ""
        this.form.mobile = ""
        this.form.name = ""
    },
    // 导航跳转
    go(index) {
      this.$router.push(index);
    },
    showbtn(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 300) {
        $(".nav").addClass('fixed');
      } else {
        $(".nav").removeClass('fixed');
      }
      if(scrollTop > 90) {
        $(".nav").addClass('opacity');
      } else {
        $(".nav").removeClass('opacity');
      }
    },
    eng() {
      this.$message.info("暂未开通")
    }
  }
};
</script>
<style lang="scss" scoped>
.nav {
  max-width: 1920px;
  min-width: $min-screen-width;
  margin: 0 auto;
  position: relative;
  z-index: 100;
  .inner {
    display: flex;
    align-items: center;
    background: #fff;
    img {
      width: 198px;
      height: 47px;
      position: absolute;
      top: 21px;
      // left: 188px;
      left: 10%;
      z-index: 10000;
    }
  }
}

li {
  text-align: center;
}

.nav-bar {
  position: relative;
  z-index: 1000;
  max-width: 1920px;
  height: 90px;
  width: 100%;
}
.nav-top {
  height: 90px;
  background: #fff;
}
.nav-content {
  position: absolute;
  width: 80%;
  left: 10%;
}
.nav-content-box {
  position: absolute;
  right: 7%;
  width: 673px;
}
.nav-content-box > li {
  float: left;
  line-height: 90px;
}
.nav-content-box > li > span > span {
  display: block;
  width: 100%;
  margin: 0;
  height: 87px;
  line-height: 87px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #004999;
  cursor: pointer;
}
.nav-content-box > li:hover > span > span {
  color: #64ac3a !important;
  background: #fff;
}
.nav-content-box > li ul li span {
  border-bottom: 2px solid transparent;
}
.nav-content-box > li ul li:hover span {
  border-bottom: 2px solid #004999;
}
ul > li.index,
ul > li.pro,
ul > li.programme,
ul > li.case,
ul > li.about {
  width: 130px;
  position: relative;
}

ul > li.index ul span,
ul > li.pro ul span,
ul > li.case ul span,
ul > li.about ul span {
 font-size: 14px;
 font-family: Source Han Sans CN;
 font-weight: 400;
 line-height: 20px;
 color: #004999;
 padding-bottom: 10px;
 margin-bottom: 15px;
 cursor: pointer;
}
ul > li.programme ul span{
 font-size: 14px;
 font-family: Source Han Sans CN;
 font-weight: 400;
 line-height: 18px;
 color: #004999;
 padding-bottom: 10px;
 margin-bottom: 15px;
 cursor: pointer;
}
ul > li.index {
  height: 43px;
}

ul.nav-content-box li ul li {
  float: left;
  width: 100%;
  line-height: 2;
  text-align: center;
}
ul.nav-content-box > li > ul > li > span {
  display: block;
  width: 100%;
}
.nav-bar .nav-content-box li ul {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
}
.nav-bar .nav-content-box li ul.pro-item {
  height: 214px;
}
.nav-bar .nav-content-box li ul.programme-item {
  width: 160px;
  height: 115px;
  box-sizing: border-box;
}
.nav-bar .nav-content-box li ul.case-item {
  height: 212px;
}
.nav-bar .nav-content-box li ul.about-item {
  height: 118px;
}
.nav-content-box > li {
  height: 90px;
}
.nav-content-box li > ul li:nth-child(1) {
  padding-top: 24px;
}
.nav-content-box > li > ul {
  opacity: 0;
  height: 0;
  visibility: hidden;
  // display: none;
  transition: opacity .75s;
  border-radius: 0 0 5px 5px;
  background: #fff;
  position: relative;
  top: 2px;
}
.nav-content-box li:hover > ul,
.nav-content-box li:hover ul,
.nav-content-box li:hover ul,
.nav-content-box li:hover ul{
  opacity: 1;
  visibility: visible;
  // display: block;
}

.bottom-line {
  position: absolute;
  top: 65px;
  left: 28px;
  display: block;
  width: 75px;
  height: 2px;
  background: #64AC3A;;
  z-index: 10000;
  display: none;
}

.show-line {
  display: block;
}

.opacity {
  transition: opacity .75s;
  opacity: 0;
}

.fixed {
  position: fixed;
  z-index: 20;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
  opacity: 1;
}

.showLine {
  display: block;
}

.btn {
  position: relative;
  right: 100px;
  z-index: 1001;
  .el-button--medium{
    border-radius: 20px;
  }
}

/deep/ .el-form-item__content {
  display: flex;
  span {
    color: red;
    padding-right: 10px;
  }
}

/deep/ .el-form-item__error {
  left: 17px;
}

/deep/ .el-input__inner {
  font-family: Source Han Sans CN;
}
/deep/ .el-textarea__inner {
  font-family: Source Han Sans CN;
}
</style>


// WEBPACK FOOTER //
// src/components/nav-bar.vue